import { render, staticRenderFns } from "./PrivacyTermsHeader.vue?vue&type=template&id=377d94ca&"
import script from "./PrivacyTermsHeader.vue?vue&type=script&lang=js&"
export * from "./PrivacyTermsHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTermsHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports